import React from 'react';
import { View, Pressable } from 'react-native';
import styled, { css } from 'styled-components';
import { Link } from 'react-router-dom';

import { Text } from '../styles';
import colors from '../styles/colors';
import fonts from '../styles/fonts';

const buttonBase = css`
  box-sizing: border-box;
  border-radius: 8px;
  padding: ${({ $small }) => ($small ? '8px 14px' : '12px 20px')};
  font-size: ${({ $small }) =>
    $small ? fonts.smallButton.size : fonts.button.size};
  font-weight: ${fonts.button.weight};
  font-family: inherit;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  text-decoration: none;
  white-space: nowrap;
`;

const primaryStyles = css`
  ${buttonBase}
  background-color: ${colors.buttonBackground};
  color: ${colors.textInverse};
  border: none;
`;

const secondaryStyles = css`
  ${buttonBase}
  background-color: ${colors.textInverse};
  color: ${colors.textPrimary};
  border: 1px solid ${colors.textPrimary};
`;

const disabledStyles = css`
  ${buttonBase}
  background-color: ${colors.disabled};
  color: ${colors.textInverse};
  border: none;
  cursor: not-allowed;
`;

const PrimaryLink = styled(Link)`${primaryStyles}`;
const PrimaryPlain = styled.button`${primaryStyles}`;
const SecondaryLink = styled(Link)`${secondaryStyles}`;
const SecondaryPlain = styled.button`${secondaryStyles}`;
const DisabledPlain = styled.button`${disabledStyles}`;

// An anchor ignores the disabled attribute, so a disabled button has to drop
// `to` and render as a real button to stop being clickable.
const buildButton = (LinkVariant, PlainVariant) => {
  const ButtonVariant = ({ to, small, disabled, ...props }) => {
    if (disabled) {
      return <DisabledPlain type="button" disabled $small={small} {...props} />;
    }

    return to
      ? <LinkVariant to={to} $small={small} {...props} />
      : <PlainVariant type="button" $small={small} {...props} />;
  };
  return ButtonVariant;
};

export const PrimaryButton = buildButton(PrimaryLink, PrimaryPlain);
export const SecondaryButton = buildButton(SecondaryLink, SecondaryPlain);

export const ButtonGroup = styled(View)`
  flex-direction: row;
  gap: 8px;
  justify-content: flex-end;
`;

export const ButtonContainer = styled(View)`

`;

const PRESSABLE_STYLES = `
  background-color: ${colors.elRed};
  padding: 6px;
  border-radius: 4px;
  align-items: center;
  margin-top: 10px;
  margin-bottom: 10px;
`;

const PressableContainer = styled(Pressable)`
  ${PRESSABLE_STYLES}
`;

const ButtonText = styled(Text)`
  font-size: 16px;
  color: white;
  font-weight: 600;
  text-decoration-line: none;
  text-align: center;
`;

// React-native Pressable button (onPress/label API) still used by
// ConfirmSeller and Conversation/Emoji; new web code should use
// PrimaryButton/SecondaryButton above.
export const Button = ({ label, ...props }) => {
  props.style ||= {};
  const textStyle = {color: '#fff', fontWeight: 'bold', fontSize: '18px',
    textAlign: 'center'
  };

  if ('Cancel' === props.type) {
    props.style.backgroundColor ||= colors.cancel;
    label ||= 'Cancel';
  }

  return (
    <PressableContainer {...props}>
      <ButtonText style={textStyle}>{label}</ButtonText>
    </PressableContainer>
  );
}
